import { type FC, memo } from "react";
import { Heading } from "@stubhub/broadway-web";
import { useFormattedContent } from "src/shared/components/content/hooks";
import { useEventsGridContext } from "src/website-apps/shared/context/events-grid-context";
import { showsAvailableCountStyles } from "./styles";

/**
 * Renders a count of available shows or parking passes, e.g. "42 shows available".
 * Derives count from the live calendar grid state so it updates when filters change.
 * Returns null when count is 0 or undefined.
 */
export const ShowsAvailableCount: FC = memo(() => {
  const [state] = useEventsGridContext();
  const count = state.grids?.reduce((sum, g) => sum + (g.totalCount ?? 0), 0) ?? 0;
  const availableShowsContentSingular = useFormattedContent("cid$#4248116#", [String(count)]); // "{count} event available"
  const availableShowsContentPlural = useFormattedContent("cid$#4248117#", [String(count)]); // "{count} events available"
  const content = count === 1 ? availableShowsContentSingular : availableShowsContentPlural;

  if (!count) return null;

  return (
    <div className={showsAvailableCountStyles.container}>
      <Heading as="h2" variant="title" size="medium" style={{ marginBlock: 0 }}>
        {content}
      </Heading>
    </div>
  );
});

ShowsAvailableCount.displayName = "ShowsAvailableCount";
